// Game Configuration Constants
// Adjust these values to change core game mechanics
export const MAX_PLAYERS = 12;  // Can be adjusted based on server capacity and game balance
export const MIN_PLAYERS = 2;
export const DEFAULT_ROUND_TIME = 60; // seconds
export const MIN_ROUND_TIME = 30;
export const MAX_ROUND_TIME = 120;
export const MIN_ROUNDS = 5;
export const MAX_ROUNDS = 20;
export const DEFAULT_MAX_ROUNDS = 10;

// Room Code Configuration
export const ROOM_CODE_LENGTH = 6;

// Points Configuration
export const POINTS = {
    CORRECT_GUESS: 100,
    CLOSE_GUESS: 50,
    PROMPT_CREATOR: 25, // points for each correct guess of your prompt
};

// Timeouts and Intervals
export const TIMEOUTS = {
    ERROR_MESSAGE: 3000, // 3 seconds
    SUCCESS_MESSAGE: 2000, // 2 seconds
    ROUND_END_DELAY: 5000, // 5 seconds before next round
};

// Default Game Settings
export const DEFAULT_GAME_SETTINGS = {
    maxPlayers: MAX_PLAYERS,
    roundTime: DEFAULT_ROUND_TIME,
    maxRounds: DEFAULT_MAX_ROUNDS,
}; 